import { render } from "./CorporateForm.vue?vue&type=template&id=c6df7fae&scoped=true"
import script from "./CorporateForm.vue?vue&type=script&lang=js"
export * from "./CorporateForm.vue?vue&type=script&lang=js"

import "./CorporateForm.vue?vue&type=style&index=0&id=c6df7fae&scoped=true&lang=css"

import exportComponent from "/home/forge/mymembership.id/releases/82161804/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c6df7fae"]])

export default __exports__